import { Action, createReducer, on } from '@ngrx/store';
import { setPeekingAssistantDisabled, setPeekingAssistantFundType } from '../actions/peeking-assistant.action';
import { initialPeekingAssistantState, PeekingAssistantState } from '../state/peeking-assistant.state';

export const featurePeekingAssistantKey = 'peekingAssistant';

const _peekingAssistantReducer = createReducer<PeekingAssistantState, Action>(
  initialPeekingAssistantState,
  on(setPeekingAssistantDisabled, (state, { disabled }) => {
    return { ...state, disabled };
  }),
  on(setPeekingAssistantFundType, (state, { fund_type }) => {
    return { ...state, fund_type };
  })
);

export function peekingAssistantReducer(state: PeekingAssistantState | undefined, action: Action) {
  return _peekingAssistantReducer(state, action);
}
